<div id="campaign-influencer-detail-container" class="workspace">
  <div class="col-md-12 col-sm-12 d-flex flex-row">
    <div class="col-md-8 col-sm-8 d-flex flex-row justify-content-start">
      <div class="back-btn d-flex justify-content-center align-items-center" (click)="back()">
        <svg width="8px" height="20px" viewBox="0 0 19 41" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g transform="translate(-12.000000, -4.000000)" fill="#000000">
              <path d="M28.949609,44.5859918 L12,24.4995264 L28.949609,4.41407071 C29.3745432,3.90817291 30.1162287,3.86071343 30.6006146,4.29996602 C31.0869498,4.74022838 31.1356807,5.50563864 30.7107466,6.00951689 L15.1061126,24.4995264 L30.7107466,42.9905456 C31.1356807,43.4944239 31.0869498,44.2598341 30.6006146,44.6990867 C30.3784013,44.9000322 30.1045332,45 29.8306651,45 C29.5051422,45 29.1815685,44.8596411 28.949609,44.5859918 Z" id="Fill-1"></path>
            </g>
          </g>
        </svg>
      </div>

      <div class="flex-row justify-content-center align-items-center">
        <div class="d-flex flex-row flex-wrap breadcumb-header">
          <a class="not-underline text-semi-bold-font" (click)="back()">{{'group_campaigns_add.breadcumd_root' | translate}}</a>
          <span class="d-flex align-items-center ml-2 mr-2" *ngIf="campaignName !== ''">
            <svg width="14" height="13" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 16">
              <path d="M 0.43182156,15.2625 C 0.80680249,15.213584 0.96030581,14.807413 1.2100589,14.567411 3.1455498,12.255301 5.0810407,9.9431903 7.0165316,7.63108 4.9300849,5.1387667 2.8436382,2.6464533 0.75719156,0.15414 0.34255348,-0.34508242 -0.3240075,0.45648886 0.17152218,0.82533571 2.0708387,3.0939171 3.9701551,5.3624986 5.8694716,7.63108 3.9485883,9.9255533 2.0277049,12.220027 0.10682156,14.5145 c -0.24165099,0.270335 -0.048168,0.753498 0.325,0.748 z"
                fill="#95A0B1" fill-rule="nonezero"></path>
            </svg>
          </span>
          <a class="not-underline text-light-font">{{campaignName}}</a>
          <div class="button-icon">
            <a class="icon-edit" actionByLevels="Basic brief" [wallName]="'Campaigns Disabled'" (afterChecking)="openCampaignDetails(campaignId)"></a>
          </div>
        </div>
        <div class="col-md-12 breadcumb-subheader">{{'campaigns.campaign_influencer_detail.subtitle' | translate}}</div>
        <div class="col-md-12 d-flex flex-row post-counting">
          <div class="post-counting-label">{{'campaigns.campaign_influencer_detail.post_counting_label' | translate}}</div>
          <div>{{campaignTotalPost}}</div>
          <div class="post-change" *ngIf="numberOfPostChange > 0">{{ 'campaigns.campaign_influencer_detail.post_change' | translate: {numberOfPostChange: numberOfPostChange} }}</div>
        </div>
      </div>
    </div>
    <div class="col-md-4 col-sm-4  d-flex justify-content-end">
      <div class="search-box-container">
        <achoo-text-field placeholder="{{'group_details.search_placeholder' | translate}}"
                          [isPageSearch]="true"
                          [(model)]="searchCriteria.searchString"
                          (modelChange)="searchInfluencerByText($event)"
                          placement="bottom"
                          ngbTooltip="{{'info_box.group_details.search' | translate}}">
        </achoo-text-field>
      </div>
    </div>
  </div>
  <div class="col-md-12 col-sm-12 search-bar-container">
    <search-bar [countryList]="countryList" [platFormList]="platformList"
                [influencerSearch]="searchCriteria"
                [isCampaignInfluencer]="true"
                [campaignData]="campaignData"
                (checkEvent)="selectAllInfluencer($event)"
                (searchEvent)="advanceSearchInfluencerList($event)"
    ></search-bar>
  </div>
  <div class="col-md-12 col-sm-12">
    <div class="influencers-item-container" *ngFor="let influencer of influencerList">
      <influencer-item [influencer]="influencer"
                       [isCampaignInfluencer]="true"
                       [campaignId]="campaignId"
                       [isLoadingData]="isLoadingData"
                       (eventSelectInfluencer)="onSelectSingleInfluencer($event)"></influencer-item>
    </div>
    <div class="empty-message" *ngIf="showEmptyResultMessage && !isLoadingData">
      {{'group_details.empty_result' | translate}}
    </div>
  </div>
</div>
<div class="bottombar"
     [ngClass]="{'open': activeBottomBar === 'active', 'collapsed': activeBottomBar === 'inactive'}">
  <div class="row full-height">
    <div class="col-md-12 col-sm-12 d-flex flex-g1">
      <bottombar-influencer-fragement class="d-flex flex-auto full-width"
                                      [influencerList]="influencerList"
                                      [campaignList]="campaignList"
                                      [campaignId]="campaignId"
                                      [influencerGroupList]="influencerGroupList"
                                      [campaignInfluencerList]="true"
                                      [isArchivedCampaign]="isArchivedCampaign"
                                      (addInfluencerToCurrentCampaign)="addInfluencerToCurrentCampaign($event)"
                                      (addInfluencerToCampaignError)="addInfluencerToCampaignError()"
                                      (addInfluencerAsAccepted)="addInfluencerAsAcceptedSuccess()"
                                      (closeBottomBarCallback)="closeBottonBar()"
                                      (openBottomBarCallback)="beforeActiveBottomBar()"
                                      (deleteInfluencerEvent)="deleteInfluencerFromBottomBar($event)">
      </bottombar-influencer-fragement>
    </div>
  </div>
</div>
<achoo-popup #InfluencerListError
             [isNotification]="true"
             modelTitle="{{'common.alert' | translate}}">
  <span>{{errorMessage}}</span>
</achoo-popup>
<achoo-popup #SelectAllInfluencers
             [isNotification]="true"
             modelTitle="{{'notification.notice' | translate}}">
  <span>{{'group_details.influencer.select_all' | translate:{selected_influencer: numberOfSelectedInfluencers} }}</span>
</achoo-popup>
<achoo-popup #SearchErrorDialog
             [isAlertPopup]="true"
             [acceptBtnLabel]="'common.btn.retry' | translate"
             [cancelBtnLabel]="'common.btn.cancel' | translate"
             (acceptCallback)="onRetrySeacrh()"
             (cancelCallback)="closePopup()">
  <span>{{'campaigns.campaign_influencer_detail.api_search_fail' | translate}}</span>
</achoo-popup>



// WEBPACK FOOTER //
// ./src/app/main/influencer-list/influencer-list.component.html